'use strict';

var Decco = require("decco/lib/js/src/Decco.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Request$PvpcontrollerWeb = require("./Request.js");

function hasPermission(permissions, permission) {
  return permissions.split(",").some(function (p) {
              return p === permission;
            });
}

function hasManagePermission(permissions) {
  if (hasPermission(permissions, "pvpmanager.use")) {
    return true;
  } else {
    return hasPermission(permissions, "*");
  }
}

function tokenResponse_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var valid = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "valid"), null));
  if (valid.TAG === /* Ok */0) {
    var id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */0) {
      var avatar = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "avatar"), null));
      if (avatar.TAG === /* Ok */0) {
        var username = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "username"), null));
        if (username.TAG === /* Ok */0) {
          var permissions = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "permissions"), null));
          if (permissions.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      valid: valid._0,
                      id: id._0,
                      avatar: avatar._0,
                      username: username._0,
                      permissions: permissions._0
                    }
                  };
          }
          var e = permissions._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".permissions" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = username._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".username" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = avatar._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".avatar" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".id" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = valid._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".valid" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function tokenValidResponse(json) {
  var response = tokenResponse_decode(json);
  if (response.TAG !== /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: /* NotVerified */0
          };
  }
  var match = response._0;
  var userId = match.id;
  if (userId === undefined) {
    return {
            TAG: /* Ok */0,
            _0: /* NotVerified */0
          };
  }
  var avatar = match.avatar;
  if (avatar === undefined) {
    return {
            TAG: /* Ok */0,
            _0: /* NotVerified */0
          };
  }
  var username = match.username;
  if (username === undefined) {
    return {
            TAG: /* Ok */0,
            _0: /* NotVerified */0
          };
  }
  var permissions = match.permissions;
  if (permissions !== undefined) {
    if (hasManagePermission(permissions)) {
      return {
              TAG: /* Ok */0,
              _0: {
                TAG: /* Verified */0,
                _0: userId,
                _1: username,
                _2: avatar
              }
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: {
                TAG: /* VerifiedNoManage */1,
                _0: userId,
                _1: username,
                _2: avatar
              }
            };
    }
  } else {
    return {
            TAG: /* Ok */0,
            _0: /* NotVerified */0
          };
  }
}

function verify(sessionId, token, cb) {
  var encodedSessionId = encodeURIComponent(sessionId.toString());
  var encodedToken = encodeURIComponent(token);
  return Request$PvpcontrollerWeb.getWithDecoder("https://loginapi.dark-gaming.com/api/verify/" + encodedSessionId + "/" + encodedToken, tokenValidResponse, cb);
}

exports.verify = verify;
/* No side effect */
